import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Field, useFormikContext } from 'formik';
import { debounceIndexShiftsRequest } from '../../../requests/shifts';
import { pairValue, resultFetchData } from './utils';
import { InputSelect } from '../Select';

const ShiftsFilter = ({ formikValue, params = {} }) => {
  const dispatch = useDispatch();
  const { values, setFieldValue } = useFormikContext();
  const [shifts, setShifts] = useState([]);

  const fetchShifts = (inputValue, callback) => {
    const request = async () => {
      debounceIndexShiftsRequest({
        dispatch,
        params: {
          actives: true,
          name: inputValue,
          sort_column: 'name',
          paginate: false,
          ...params
        },
        successCallback: data => {
          const options = resultFetchData(data);
          setShifts(options);
          callback(options);
        }
      });
    };
    request();
  };

  return (
    <Field name={formikValue}>
      {({ field }) => (
        <InputSelect
          {...field}
          label="Turno"
          placeholder="Seleccionar Turno"
          request={fetchShifts}
          value={values[formikValue]}
          defaultValue={pairValue(shifts, values[formikValue])}
          onChange={data => setFieldValue(field.name, data ? data.value : '')}
          isClearable
        />
      )}
    </Field>
  );
};

export default ShiftsFilter;
